import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import container from '../../helpers/container'
import format from '../../helpers/format'
import {
  Works,
  Link,
  LinkIcon,
  GetStartedInput,
  Grade,
  Changelog
} from '../../components'
import ReactTooltip from 'react-tooltip'
import Styles from './HowItWorks.css'

@CSSModules(Styles)
export default class HowItWorks extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'How it works'
    const description = `Gender Equality Funds tracks thousands of mutual
      funds commonly found in retirement plans.`
    const url = config.domain + config.routes.howitworks

    const bannerImage = 'green'
    const bannerHeadline = 'How it works'
    const bannerSubtitle = 'Getting started with Gender Equality Funds'

    // IMAGES
    const sriIcon = require('../../../static/images/sri.png')
    const ussifIcon = require('../../../static/images/ussif-logo.png')
    const equileapLogo = require('../../../static/images/equileap-logo.png')
    // const equileapStamp = require('../../../static/images/equileap-stamp.png')
    const iyvLogo = require('../../../static/images/iyv-logo-project-of-2021.jpg')
    const subscoreAIcon = require(
      '../../../static/images/GEF-icons-gender-balance-peer-rank.svg'
    )
    const subscoreBIcon = require(
      '../../../static/images/GEF-icons-gender-equality-peer-rank.svg'
    )
    const subscoreCIcon = require(
      '../../../static/images/GEF-icons-gender-equality-policies-rank.svg'
    )
    const subscoreDIcon = require(
      '../../../static/images/GEF-icons-gender-equality-policies-score.svg'
    )
    const gefScoreExample = require(
      '../../../static/images/gef-score-example.png'
    )
    const gefRankingExample = require(
      '../../../static/images/gef-ranking-example.png'
    )
    const gefSubScoreExample = require(
      '../../../static/images/gef-sub-score-example.png'
    )
    const gefSubRankingExample = require(
      '../../../static/images/gef-sub-ranking-example.png'
    )
    const gefChartBExample = require(
      '../../../static/images/example_gef_chartB.png'
    )
    const gefChartAExample = require(
      '../../../static/images/example_gef_chartA.png'
    )
    const gefIyvReportCardExample = require(
      '../../../static/images/example-iyv-report-card.png'
    )

    // CONFIG FOR CATEGORY LISTING
    const cats = {
      'U.S. Large Cap Equity' : [
        'Large Blend',
        'Large Growth',
        'Large Value',
      ],
      'U.S. Small/Mid Cap Equity' : [
        'Mid-Cap Blend',
        'Mid-Cap Growth',
        'Mid-Cap Value',
        'Small Blend',
        'Small Growth',
        'Small Value'
      ],
      'Allocation' : [
        'Allocation--15% to 30% Equity',
        'Allocation--30% to 50% Equity',
        'Allocation--50% to 70% Equity',
        'Allocation--70% to 85% Equity',
        'Allocation--85%+ Equity',
        'Convertibles',
        'Tactical Allocation',
        'Target Date 2010',
        'Target-Date 2015',
        'Target-Date 2020',
        'Target-Date 2025',
        'Target-Date 2030',
        'Target-Date 2035',
        'Target-Date 2040',
        'Target-Date 2045',
        'Target-Date 2050',
        'Target-Date 2055',
        'Target-Date 2060+',
        'Target-Date Retirement',
        'World Allocation'
      ],
      'International Equity' : [
        'China Region',
        'Diversified Emerging Mkts',
        'Diversified Pacific/Asia',
        'Europe Stock',
        'Foreign Large Blend',
        'Foreign Large Growth',
        'Foreign Large Value',
        'Foreign Small/Mid Blend',
        'Foreign Small/Mid Growth',
        'Foreign Small/Mid Value',
        'India Equity',
        'Japan Stock',
        'Latin America Stock',
        'Miscellaneous Region',
        'Pacific/Asia ex-Japan Stk',
        'World Large Stock',
        'World Small/Mid Stock'
      ],
      'Sector Equity' : [
        'Commodities Broad Basket',
        'Commodities Precious Metals',
        'Communications',
        'Consumer Cyclical',
        'Consumer Defensive',
        'Energy Limited Partnership',
        'Equity Energy',
        'Equity Precious Metals',
        'Financial',
        'Global Real Estate',
        'Health',
        'Industrials',
        'Infrastructure',
        'Miscellaneous Sector',
        'Natural Resources',
        'Real Estate',
        'Technology',
        'Utilities'
      ],
    }
    const keys = Object.keys(cats)

    return (
      <div>
        {container.helmet(title, description, url)}

        { /* TOP BANNER */ }
        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-' + bannerImage}>
                <div styleName='image-banner-headline'>
                  {bannerHeadline}
                </div>
                <div styleName='image-banner-subtitle'>
                  {bannerSubtitle}
                </div>
              </div>
            </div>
          </div>
        </div>

        { /* LEDE PARAGRAPH */ }
         <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>

               { /* <div styleName='title'>
                Methodology
               </div> */ }

               <div styleName='lede'>
                  The <strong>Gender Equality Funds</strong> database covers
                  thousands of the most commonly-held U.S. mutual funds, the
                  type of investments most common in retirement plans like
                  employer-offered 401(k)s.
               </div>

                { /* CHANGELOG */ }
                <Changelog />

             </div>
           </div>
         </div>

        { /* HOW IT WORKS BANNER */ }
        <Works/>

      { /* PRE-METHODOLOGY CONTENT */ }
        <div styleName='x-fund-container'>
          <div styleName='x-fund-container-inner'>
              <div styleName='x-fund-info-photo'>
                <div styleName='x-fund-photo' title='401k retirement plans'/>
                <div styleName='x-fund-info'>
                  <div styleName='x-fund-info-title'>
                    Mutual funds
                  </div>
                  <p>
                    Mutual funds are collections of stocks bundled together,
                    often hundreds or thousands of companies. They are some of
                    the most popular investment products for retirement plans
                    – owning so many company stocks at once helps diversify
                    investment risk. But it is difficult to find out and track
                    exactly what companies are inside the funds you're
                    invested in. That’s where we come in. We examine every
                    holding in thousands of funds, in order to calculate
                    gender equality scores, rankings, and grades.
                  </p>
                </div>
              </div>
          </div>
        </div>
        <div styleName='x-sri-container'>
          <div styleName='x-sri-container-inner'>
              <div styleName='x-sri-info-photo'>
                <div
                  styleName='x-sri-photo'
                  title='401k retirement plans'
                />
                <div styleName='x-sri-info'>
                  <div styleName='x-sri-info-title'>
                    Sustainable investing
                  </div>
                  <p>
                    Some funds actively choose to invest sustainably, by
                    considering gender equality issues or other environmental
                    and social issues when choosing companies to invest in. If
                    you're thinking about gender lens investing, sustainable
                    funds can be a good place to start, because they often
                    deliberately seek out companies that have strong diversity
                    and equal opportunity policies. We feature nearly over a
                    hundred sustainably-mandated funds in our database.
                  </p>
                </div>
              </div>
          </div>
        </div>
        <div styleName='x-returns-container'>
          <div styleName='x-returns-container-inner'>
              <div styleName='x-returns-info-photo'>
                <div
                  styleName='x-returns-photo'
                  title='401k retirement plans'
                />
                <div styleName='x-returns-info'>
                  <div styleName='x-returns-info-title'>
                    Sustainable investing can offer competitive returns
                  </div>
                  <p>
                    While people may become interested in gender lens
                    investing and sustainable investing because of personal
                    values and goals, that doesn't mean they're not looking
                    for a competitive financial return on their investments.
                    Fortunately, the evidence is clear: sustainable and
                    responsible investors do not have to sacrifice returns to
                    align investments with their values, according to <Link
                      to={config.links.equileapResearch}
                      title='Research Papers | Equileap'
                      xstrong
                    >Equileap</Link> and <Link
                      to={config.links.ussifperf}
                      title={
                        'Performance and SRI | The Forum for Sustainable ' +
                          'and Responsible Investment'
                      }
                      xstrong
                    >the Forum for Sustainable and Responsible
                    Investment</Link>.
                  </p>
                </div>
              </div>
          </div>
        </div>

        { /* MAIN METHODOLOGY CONTENT */ }
        <div styleName='how-it-works'>
          <div styleName='how-it-works-inner'>

            <div styleName='title'>
              How we score mutual funds
            </div>
            <div styleName='lede'>
              To power Gender Equality Funds, we combine two detailed data
              sources: <strong>company gender equality data</strong> from
              Equileap, and <strong>mutual fund holdings data</strong> from
              Morningstar.
            </div>

            <div styleName='answer-title'>
              Equileap
            </div>
            <div styleName='answer-info'>
              <p>
                <Link
                  to={config.links.equileap}
                  xstrong
                  title='Equileap'
                >Equileap</Link> is a social venture that aims to accelerate
                progress towards gender equality in the workplace as a vital
                lever in reducing poverty and inequality. Equileap tackles its
                mission by collecting and checking data, carrying out research,
                and ranking and rating companies on their gender equality
                performance. It supports investors to deploy their capital with
                a gender lens, companies to improve their performance, and
                policy makers to bring in effective frameworks to increase
                gender equality at work.
              </p>
              <Link to={config.links.equileap} title='Equileap'>
                <img
                  styleName='logo-equileap'
                  src={equileapLogo}
                  alt='Equileap'
                />
              </Link>
            </div>

            <div styleName='answer-title'>
              Equileap Gender Equality Scorecard
            </div>
            <div styleName='answer-info'>
              <p>
                <strong>Gender Equality Funds</strong> is powered by
                the <Link
                  to={config.links.equileapResearch}
                  title='Equileap reports - Equileap'
                  xstrong
                >Equileap Gender Equality Scorecard</Link>, inspired by the
                UN’s Women Empowerment Principles. The Equileap Gender
                Equality Scorecard scores companies based on 19 criteria,
                including gender balance across the workforce, the gender
                pay gap, paid parental leave, and anti-sexual harassment
                policies.
              </p>
              <p>
                Equileap researches nearly 3,500 companies, gathering publicly
                available information provided by the companies themselves,
                including in their annual reports, sustainability reports
                and/or on their websites. Each company is assigned a <i>gender
                equality score</i> between 0 and 100. These overall scores are
                based on four sub-scores:
              </p>
              <ul>
                <li>
                  <strong>Gender balance in leadership and
                  workforce</strong> (40 possible points)
                </li>
                <li>
                  <strong>Equal compensation and work life
                  balance</strong> (30 possible points)
                </li>
                <li>
                  <strong>Policies promoting gender equality</strong> (20
                  possible points)
                </li>
                <li>
                  <strong>Commitment, transparency, and
                  accountability</strong> (10 possible points)
                </li>
              </ul>
              <p>
                For each of the 19 gender equality criteria a question has
                been defined, and a data point has been identified to answer
                the question. Lastly, a score and weighting has been allocated
                to the individual question to reflect the judgement that some
                criteria may be more important for furthering gender equality
                than others. For more details, refer to the <Link
                  to={config.links.equileapResearch}
                  title='Equileap reports - Equileap'
                  xstrong
                >Equileap Gender Equality Global Report and Ranking</Link>.
              </p>
              <div styleName='lower-lede-col-2'>
                <div styleName='small-title'>
                  <div styleName='icon-label-wrap'>
                    <img
                      src={subscoreAIcon}
                      alt='Gender balance in leadership and workforce'
                      styleName='inline-icon-sm'
                    />
                    <div styleName='icon-label'>
                      Gender balance in leadership and workforce
                    </div>
                  </div>
                </div>
                <ul>
                  <li>
                    <strong>1 - Board of Directors</strong> - Percentage of
                    male and female Board of Directors as a proportion of the
                    total number.
                  </li>
                  <li>
                    <strong>2 - Executives</strong> - Percentage of male and
                    female Executives as a percentage of the total number.
                  </li>
                  <li>
                    <strong>3 - Senior Management</strong> - Percentage of
                    male and female senior managers as a percentage of total.
                  </li>
                  <li>
                    <strong>4 - Workforce</strong> - Percentage of male and
                    female employees as a percentage of total.
                  </li>
                  <li>
                    <strong>5 - Promotion and Career Development
                    Opportunities</strong> - Ratio of each gender in Senior
                    Management compared to ratio of each gender in the
                    Workforce.
                  </li>
                </ul>
              </div>
              <div styleName='lower-lede-col-2'>
                <div styleName='small-title'>
                  <div styleName='icon-label-wrap'>
                    <img
                      src={subscoreBIcon}
                      alt='Equal compensation and work life balance'
                      styleName='inline-icon-sm'
                    />
                    <div styleName='icon-label'>
                      Equal compensation and work life balance
                    </div>
                  </div>
                </div>
                <ul>
                  <li>
                    <strong>6 - Living Wage</strong> - Commitment to ensure
                    payment of a living wage to all employees, even in those
                    countries that do not legally require a minimum wage or
                    where minimum wage is not a living wage.
                  </li>
                  <li>
                    <strong>7 - Gender Pay Gap</strong> - Commitment to
                    provide comparable wages for comparable work and to close
                    the gender pay gap.
                  </li>
                  <li>
                    <strong>8 - Parental Leave</strong> - Paid leave programs
                    (at least 2/3 paid) for child care to both primary or
                    secondary carers globally or at least in the country of
                    incorporation.
                  </li>
                  <li>
                    <strong>9 - Flexible Work Options</strong> - Option for
                    employees to control and/or vary the start and end times
                    of the work day and/or vary the location from which
                    employees work.
                  </li>
                </ul>
              </div>
              <div styleName='lower-lede-col-2'>
                <div styleName='small-title'>
                  <div styleName='icon-label-wrap'>
                    <img
                      src={subscoreCIcon}
                      alt='Policies promoting gender equality'
                      styleName='inline-icon-sm'
                    />
                    <div styleName='icon-label'>
                      Policies promoting gender equality
                    </div>
                  </div>
                </div>
                <ul>
                  <li>
                    <strong>10 - Training and Career Development</strong> -
                    Commitment to ensure equal access to training and career
                    development to both men and women.
                  </li>
                  <li>
                    <strong>11 - Recruitment Strategy</strong> - Commitment to
                    ensure non-discrimination against any type of demographic
                    group and equal opportunities to ensure gender parity.
                  </li>
                  <li>
                    <strong>12 - Freedom from Violence, Abuse and Sexual
                    Harassment</strong> - Prohibits all forms of violence in
                    the work place, including verbal, physical and sexual
                    harassment.
                  </li>
                  <li>
                    <strong>13 - Safety at Work</strong> - Commitment to the
                    safety of employees in the workplace, in travel to and
                    from the workplace, and on company related business, and
                    ensure the safety of vendors in the workplace.
                  </li>
                  <li>
                    <strong>14 - Human Rights</strong> - Commitment to ensure
                    the protection of the rights of all people it works with
                    including employees’ rights to participate in legal, civic
                    and political affairs.
                  </li>
                  <li>
                    <strong>15 - Social Supply Chain</strong> - Commitment to
                    reduce social risks in its supply chain such as forbid
                    business related activities that condone, support, or
                    otherwise participate in trafficking, including for labor
                    or sexual exploitation.
                  </li>
                  <li>
                    <strong>16 - Supplier Diversity</strong> - Commitment to
                    ensure diversity in the supply chain, including support
                    for women owned businesses in the supply chain.
                  </li>
                  <li>
                    <strong>17 - Employee Protection</strong> - Systems and
                    policies for the reporting of internal ethical compliance
                    complaints without retaliation or retribution, including
                    but not limited to access to confidential third-party
                    ethics hotlines or systems for confidential written
                    complaints.
                  </li>
                </ul>
              </div>
              <div styleName='lower-lede-col-2'>
                <div styleName='small-title'>
                  <div styleName='icon-label-wrap'>
                    <img
                      src={subscoreDIcon}
                      alt='Commitment, transparency, and accountability'
                      styleName='inline-icon-sm'
                    />
                    <div styleName='icon-label'>
                      Commitment, transparency, and accountability
                    </div>
                  </div>
                </div>
                <ul>
                  <li>
                    <strong>18 - Commitment to Women’s Empowerment</strong> -
                    Recognition and commitment to ensuring women’s empowerment
                    in the workplace.
                  </li>
                  <li>
                    <strong>19 - Audit</strong> - Undertaken and awarded an
                    independent gender audit certificate by an Equileap
                    recognized body.
                  </li>
                </ul>
              </div>
            </div>

            <div styleName='answer-title'>
              Analyzing fund holdings
            </div>
            <div styleName='answer-info'>
              <p>
                As part of As You Sow's <Link
                  to={config.links.aysinvest}
                  xstrong
                  title='Invest Your Values | As You Sow'
                >Invest Your Values program</Link>, we’ve built a series of
                tools analyzing mutual funds on environmental and social
                issues like climate change, deforestation, tobacco, and weapon
                investments.
              </p>
              <p>
                To power these sites, we source financial data on mutual funds
                and equities from <Link
                  to={config.links.morningstar}
                  xstrong
                  title='Morningstar'
                >Morningstar</Link>. This dataset covers global equities and
                thousands of U.S. open end mutual funds, as well as ETFs. It
                allows us to combine research about what industries companies
                are involved in, and what companies funds are investing in,
                to create fund scoring methodologies that grade funds on how
                exposed they are to different types of environmental and
                social investment risk.
              </p>
              <Link
                to={config.links.aysinvest}
                title='Invest Your Values - As You Sow'
              >
                <img
                  styleName='logo-iyv'
                  src={iyvLogo}
                  alt='Invest Your Values - As You Sow'
                />
              </Link>
            </div>
            <div styleName='sidebar'>
              <div styleName='sidebar-title'>
                <LinkIcon faclass='fa-info-circle' nospace/>
                &nbsp;
                <em>Measuring long holdings only</em>
              </div>
              <div styleName='sidebar-info'>
                <p>
                  When calculating a fund's exposure to a screen list, we only consider the portfolio's long investments, ignoring any shorts or liabilities. The formula for holding weight is <em>holding market value divided by the sum of the market value for all long holdings in the portfolio.</em>
                </p>
              </div>
            </div>
            <div styleName='answer-title'>
              Using company gender equality data to score fund portfolios
            </div>
            <div styleName='answer-info'>
              <p>
                To calculate gender equality scores for mutual funds, we start
                with the Equileap company scores, and cross-reference them
                with the holdings in each mutual fund. For each holding in a
                fund’s portfolio that is covered by the Equileap Gender
                Scorecard, we average the company-level scores, weighted by
                the amount the fund has invested, to calculate an overall
                gender equality score for the fund.
              </p>
              <p>
                When averaging, we weight the scores by the market value of
                the holding. This means if a fund has more money invested in
                one holding compared to another, the Equileap score of the
                holding with more assets invested counts more towards the
                average.
              </p>
              <p>
                The companies analyzed by Equileap cover nearly 90% of the
                total investments of the funds we scored. Not every holding is
                scored, but for most funds, a large percentage of their
                holdings have been scored by Equileap.
              </p>
              <p>
                Each of the funds we analyzed is based in the U.S., offered as
                an open-end mutual fund or ETF, is at least 40% invested in
                direct stock holdings, and has at least 33% Equileap
                coverage – that is, at least 33% of the long-position holdings
                are stocks issued by companies that were scored by Equileap.
              </p>
              <p>
                Currently, our analysis is focused on stock investments – we
                don’t score bond funds, or other non-stock-based funds.
              </p>
              <img
                styleName='chart-img'
                src={gefScoreExample}
                alt='Gender Equality Funds score example'
              />
              <p>
                <small><em>An example gender equality score for a fund. The
                score is calculated as a market value-weighted average of
                the individual company scores of the fund holdings, on
                Equileap’s 100-point scale. The weighted average is roudned to
                the nearest whole number.</em></small>
              </p>
            </div>

            <div styleName='answer-title'>
              Ranking fund gender equality scores
            </div>
            <div styleName='answer-info'>
              <p>
                For a fund to earn a score of 100 out of 100 points, it would
                have to only invest in companies that earn the highest
                available score from Equileap, a 100 out of 100.
              </p>
              <p>
                Unfortunately, currently there are zero companies that earn
                Equileap’s highest available score score. That means earning
                an overall gender equality score of 100 points is unattainable
                for mutual funds, until companies shift.
              </p>
              <p>
                To give a relative sense of whether a fund is doing better or
                worse than other funds, in addition to the gender equality
                score, we also rank the fund. Each fund is ranked in three
                groupings:
              </p>
              <ul>
                <li>
                  <strong>All funds:</strong> the entire universe of 4,500+
                  scored funds
                </li>
                <li>
                  <strong>Groups:</strong> one of four Morningstar category
                  groups: <strong>allocation
                  funds</strong>, <strong>international equity
                  funds</strong>, <strong>sector equity
                  funds</strong>, or <strong>U.S. equity funds</strong>.
                </li>
                <li>
                  <strong>Categories:</strong> one of 70+ Morningstar
                  categories, which serve as sub-categories of the four larger
                  groups
                </li>
              </ul>
              <p>
                The rankings are presented as percentile rankings. If a fund
                earns a group ranking of 75, that can be read as: "This fund
                ranked better than or equal to 75% of the other funds in the
                same fund group." If a fund earns an overall ranking of 50,
                that can be read as: "This fund ranked better than or equal to
                50% of all other funds in the dataset."
              </p>
              <p>
                Finally, an A-B-C-D-F letter grade is assigned based on which
                quintile the fund’s ranking places it: "A grade" funds are in
                the top 20% of their group, and so on, with "F grade" funds in
                the bottom 20% of their group.
              </p>

              <div styleName='risk-bullets'>
                <div styleName='risk-bullet'>
                  <Grade grade={1} square/>
                  <p styleName='screen-icon-label'>
                    Fund score is in 81st-100th percentile of group, the highest tier.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={2} square />
                  <p styleName='screen-icon-label'>
                    Fund score is in 61st-80th percentile of group.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={3} square />
                  <p styleName='screen-icon-label'>
                    Fund score is in 41st-60th percentile of group.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={4} square />
                  <p styleName='screen-icon-label'>
                    Fund score is in 21st-40th percentile of group.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                <Grade grade={5} square />
                <p styleName='screen-icon-label'>
                  Fund score is in 1st-20th percentile of group, the lowest tier.
                </p>
                </div>
              </div>

              <br/>
              <p>
                In addition to the A-B-C-D-F grades, several funds earn a
                special Engagement Grade in recognition of strong efforts
                to promote gender equality, diversity disclosures, racial
                justice, and LGBTQ+ equity beyond the portfolio.
              </p>

              <div styleName='risk-bullets'>
                <div styleName='risk-bullet'>
                  <Grade grade={2.5} square/>
                  <p styleName='screen-icon-label'>
                    Fund earns an Engagement Grade, representing a firm
                    committment to corporate engagement, community and
                    stakeholder engagement, and impact investing in support
                    of equity and justice.
                  </p>
                </div>
              </div>

              <br/>
              <br/>

              <p>
                <small><em>An example gender equality grade and percentile
                rank for a fund. Funds are assigned a letter grade based on
                where their gender equality score ranks within their assigned
                group. In this example, the fund’s gender equality score
                ranked 926 out of 2,371 funds in the U.S. Equity Fund group.
                This figures to a percentile ranking of 61 (i.e. the fund’s
                score is better than or equal to 61% of funds in this
                group). The fund earns a "B" grade for having a group
                percentile ranking in the 60-80 band. To see how changing the
                grouping affects the ranking, try switching to "All funds" for
                a broader universe of funds, or "Categories" for a narrower
                universe of funds. Only the group ranking is assigned a letter
                grade.</em></small>
              </p>

              <img
                styleName='chart-img'
                src={gefRankingExample}
                alt='Gender Equality Funds ranking example'
              />

              <br/>
              <br/>

              { /* <p>
                <small><em>Five letter grades are available, based on which
                quintile the fund's group ranking places it: "A grade" for
                funds in the top 20% of their group, "B grade" for funds in
                the 60-80 percentile range, "C grade" for funds in the 40-60
                percentile range, "D grade" for funds in the 20-40 percentile
                range, and "F grade" for funds in the bottom 20% of the
                group.</em></small>
              </p> */ }
              <p>
                <small><em>An example gender gender equality ranking chart for
                a fund. The orange marker represents this fund. The purple
                marker (if present) represents an assigned benchmark. Dark
                gray dots represent funds in the same grading group as this
                fund. Blue dots represent funds in the same Morningstar
                category as this fund. The higher a fund is marked on the Y
                axis, the better its gender equality score, expressed as 0-100
                points. The higher a fund is marked on the X axis, the better
                its Gender Equality Funds group ranking, expressed as a
                percentile. Based on which percentile band the fund ends up
                in, a letter grade is assigned.</em></small>
              </p>

              <img
                styleName='chart-img'
                src={gefChartAExample}
                alt='Gender Equality Funds gender equality ranking chart'
              />

            </div>

            <br/>
            <br/>

            <div styleName='group-table-wrap'>
              <p>
                <strong>Morningstar groups and categories</strong>
              </p>
              <div styleName='grp-cats-wrap'>
                { /* MAP CATEGORIES TO MAKE A SET OF BOXES */
                  keys.map((el, idx)=>{
                    const cat = cats[el].sort()
                    return <div
                      key={`grp${idx}`}
                      styleName='grp-cats-grp'
                    >
                      <div styleName='grp-cats-grp-lbl'>
                        <Link
                          to={`${config.routes.list}?grp=${el}`}
                          xstrong
                        >
                          {el}
                        </Link>
                      </div>
                      <div styleName='grp-cats-cat'>
                        {
                          cat.map((_el, _idx)=>{
                            return <div
                              key={`ct${_idx}`}
                              styleName='grp-cats-cat-lbl'
                            >
                              {_el}
                            </div>
                          })
                        }
                      </div>
                    </div>
                  })
                }
              </div>
            </div>

            <div styleName='answer-title'>
              Sub-scores and ranks
            </div>
            <div styleName='answer-info'>
              <p>
                We also calculate four sub-scores for each fund. For the four
                categories making up the Equileap Gender Equality
                Scorecard – gender balance in leadership and workforce; equal
                compensation and work life balance; policies promoting gender
                equality; and commitment, transparency, and
                accountability – we apply the same process of averaging the
                company scores, weighted by market value.
              </p>
              <p>
                The gender balance in leadership and workforce score is out of
                40 points; the equal compensation and work life balance score
                is out of 30 points; the policies promoting gender equality
                score is out of 20 points; and the commitment, transparency,
                and accountability; score is out of 10 points.
              </p>
              <p>
                For each sub-score, we also rank each fund in the same
                groupings as we do for the overall gender equality score.
              </p>
              <p>
                This breakdown can help show if the companies inside a fund
                portfolio are leading or lagging in the various areas covered
                by the Equileap Gender Equality Scorecard.
              </p>
              <img
                styleName='chart-img'
                src={gefSubScoreExample}
                alt='Gender Equality Funds sub-category score example'
              />
              <img
                styleName='chart-img'
                src={gefSubRankingExample}
                alt='Gender Equality Funds sub-category ranking example'
              />
              <p>
                <small><em>An example set of scores and ranks for the four
                sub-scores.</em></small>
              </p>
            </div>

            <div styleName='answer-title'>
              Invest Your Values report card
            </div>
            <div styleName='answer-info'>
              <p>
                Since 2015, As You Sow’s Invest Your Values free online tools
                have screened mutual fund holdings against a range of
                environmental and social issues, including climate change,
                gender equality, and weapon investments. You can see a fund’s
                results across all our tools in a single convenient report
                card. The Invest Your Values report card displays the latest
                analysis, on every issue we track, for every fund in our
                database, making it easy for you to see which funds meet your
                sustainable investing needs on gender equality, climate
                change, and more.
              </p>
              <img
                styleName='chart-img'
                src={gefIyvReportCardExample}
                alt='Invest Your Values report card example'
              />
              <p>
                <small><em>An example Invest Your Values report card for a
                fund. For various environmental and social issues, funds are
                assigned letter grades representing their results for that
                environmental or social issue. Click through to see a detailed
                analysis of the fund on our different Invest Your Values
                tools, including Fossil Free Funds, Deforestation Free Funds,
                Weapon Free Funds, and more.</em></small>
              </p>
            </div>

            <div styleName='answer-title'>
              Top and bottom-scored holdings
            </div>
            <div styleName='answer-info'>
              <p>
                We list the top 10 holdings in each portfolio with the best
                scores on the Equileap Gender Scorecard, as well as the bottom
                10 holdings with the worst scores.
              </p>
              <p>
                These lists represent the holdings that are having the biggest
                effect, both positive and negative, on the fund's overall
                gender equality score.
              </p>
              <p>
                In the case of ties, for both lists, the holding with more
                assets invested is listed higher. For example, if two holdings
                both earned zero points on the Equileap scorecard, the holding
                that had more money invested by the fund would be listed
                higher on the list of 10 worst-scoring holdings.
              </p>
            </div>

            <div styleName='answer-title'>
              Financial returns and benchmark comparisons
            </div>
            <div styleName='answer-info'>
              <p>
                Comparing to a benchmark is a common way of measuring a fund’s
                performance. You can compare each fund to a benchmark
                suggested by Morningstar, or choose from a set of common
                indexes. See whether the fund had better or worse returns than
                the benchmark, and whether it had better or worse gender
                equality scores.
              </p>
              <img
                styleName='chart-img'
                src={gefChartBExample}
                alt={
                  'Gender Equality Funds financial performance compared to ' +
                    'gender equality ranking chart'
                }
              />
              <p>
                <small><em>An example financial performance chart for a fund.
                Each fund has its annualized returns and Gender Equality Fund
                grades charted. The orange marker represents this fund. The
                purple marker (if present) represents an assigned benchmark.
                Dark gray dots represent funds in the same grading group as
                this fund. Blue dots represent funds in the same Morningstar
                category as this fund. The higher a fund is marked on the Y
                axis, the better its returns for the specified time period.
                The higher a fund is marked on the X axis, the better its
                Gender Equality Funds group ranking.</em></small>
              </p>
            </div>

            <div styleName='answer-title'>
              We track sustainably-mandated funds
            </div>
            <div styleName='answer-info'>
              <p>
                We use Morningstar’s "sustainability mandate" indicator to
                determine which funds to tag as socially responsible. Funds
                with sustainability mandates may make investment decisions
                based on issues like environmental responsibility, human
                rights, or religious views. A sustainably-mandated fund may
                take a proactive stance by selectively investing in, for
                example, environmentally-friendly companies or firms with good
                employee relations. They may also avoid investing in companies
                involved in promoting alcohol, tobacco, or firearms, or in the
                defense industry. Look for this symbol to find funds that are
                designated as having a sustainability mandate.
              </p>
              <img
                styleName='sri'
                src={sriIcon}
                alt='Sustainably-mandated fund'
                data-multiline
                data-effect='solid'
                data-html
                data-for='sri-icon-tooltip'
                data-place='bottom'
                data-tip={
                  format.tooltipHtml(
                    'Designated a sustainably-mandated fund by ' +
                    'Morningstar. Sustainably-mandated funds may ' +
                    'consider issues like the environment and human rights ' +
                    'in investment decisions.'
                  )
                }
              />

              <p>
                <Link
                  to={config.links.ussif}
                  xstrong
                  title={
                    'The Forum for Sustainable and Responsible Investment ' +
                      '(US-SIF)'
                  }
                >The Forum for Sustainable and Responsible Investment
                (US-SIF)</Link> is a group advancing sustainable, responsible,
                and impact investing. Asset managers who are members of US-SIF
                often have policies to consider the diversity and equal
                employment opportunity policies and practices of the companies
                they invest in. Look for this symbol to find funds that are
                members of US-SIF.
              </p>
              <img
                styleName='ussif'
                src={ussifIcon}
                alt={
                  'Member of US-SIF, the Forum for Sustainable and ' +
                    'Responsible Investment'
                }
                data-multiline
                data-effect='solid'
                data-html
                data-for='ussif-icon-tooltip'
                data-place='bottom'
                data-tip={
                  format.tooltipHtml(
                    'Member of US-SIF, the Forum for Sustainable and ' +
                      'Responsible Investment'
                  )
                }
              />
              
              <ReactTooltip id='sri-icon-tooltip'/>
              <ReactTooltip id='ussif-icon-tooltip'/>
            </div>

            <div styleName='answer-title'>
              Searching for alternate investments
            </div>
            <div styleName='answer-info'>
              <p>
                <Link
                  to={config.routes.clean}
                  xstrong
                  title='Search funds | Gender Equality Funds'
                >Use our search page</Link> to sort and filter our database
                and find the information you need. We track thousands of the
                most commonly-owned mutual funds in the U.S., across hundreds
                of fund families and dozens of investment categories.
              </p>
              <p>
                We’ll show you at-a-glance how the fund scores, how it ranks,
                and whether it has a sustainability mandate. For each result,
                you can click through to see the full set of scores and ranks.
              </p>
            </div>

            <div styleName='answer-title'>
              Gender-lens investing action toolkit
            </div>
            <div styleName='answer-info'>
              <p>
                When you’ve looked up funds and found the data you need,
                what's next? You can learn how to make a change and move your
                money with our <Link
                  to={config.routes.toolkit}
                  xstrong
                  title='Action toolkit | Gender Equality Funds'
                >gender-lens investing action toolkit</Link>. Whether you’re
                an individual investor or if your investments are in your
                employer-sponsored plan at work, our step-by-step toolkit can
                help. There’s an in-depth guide to responsible investing,
                links to external resources, a sample letter to send to your
                employer 401(k) manager, and more – everything you need
                to make a change and get started with gender-lens investing.
              </p>
            </div>
          </div>
        </div>

        { /* GET STARTED PANEL */ }
        <GetStartedInput />
      </div>
    )
  }
}
